import { lazy } from 'react';
import { createRoot } from 'react-dom/client';
import useAsync from 'react-use/lib/useAsync';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { setLocale } from '@rui/components';
import { loadConfig } from './app/config';
import './locales/i18n';
import './app/utils/time';
import './index.css';

if (process.env.NODE_ENV === 'production') {
  const versionText = [`buildDate: ${process.env.REACT_APP_BUILD_DATE}`, `sha: ${process.env.REACT_APP_BUILD_FULL_SHA}`].join(', ');
  console.log(`[ID TECH Status Page] ${versionText}`);
}

i18n.on('initialized', () => {
  setLocale(i18n);
});

i18n.use(initReactI18next);

const App = lazy(() => import('./app/App'));

function Root() {
  const loadingState = useAsync(async () => {
    await loadConfig();
  }, []);
  return !loadingState.loading && <App />;
}

createRoot(document.getElementById('root')).render(<Root />);
